
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class InfoIcon extends Vue {
  @Prop({ default: '#53565A' }) filled!: string;
}
